"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "rive-d-arcano": {
    "460032c1": [{
      "hkey": "1b64b360",
      "slug": "rive-d-arcano",
      "name": "Rive d'Arcano",
      "primary": true,
      "skipSearch": false
    }],
    "arcano-superiore": [{
      "hkey": "1b64b360",
      "slug": "rive-d-arcano",
      "name": "Rive d'Arcano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "448dd1df": [{
      "hkey": "1b64b360",
      "slug": "rive-d-arcano",
      "name": "Rive d'Arcano",
      "primary": true,
      "skipSearch": false
    }],
    "raucicco": [{
      "hkey": "1b64b360",
      "slug": "rive-d-arcano",
      "name": "Rive d'Arcano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4b8ca56f": [{
      "hkey": "1b64b360",
      "slug": "rive-d-arcano",
      "name": "Rive d'Arcano",
      "primary": true,
      "skipSearch": false
    }],
    "rivotta": [{
      "hkey": "1b64b360",
      "slug": "rive-d-arcano",
      "name": "Rive d'Arcano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c55c1e8a": [{
      "hkey": "c71ce36a",
      "slug": "rodeano",
      "name": "Rodeano",
      "primary": true,
      "skipSearch": false
    }],
    "rodeano-alto": [{
      "hkey": "c71ce36a",
      "slug": "rodeano",
      "name": "Rodeano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "rive-d-arcano"
    }],
    "d49158b7": [{
      "hkey": "c71ce36a",
      "slug": "rodeano",
      "name": "Rodeano",
      "primary": true,
      "skipSearch": false
    }],
    "rodeano-basso": [{
      "hkey": "c71ce36a",
      "slug": "rodeano",
      "name": "Rodeano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;